export default __webpack_public_path__ + "static/media/apple-touch-icon.7c1a5ca7.png";